import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getClientInfo = createAsyncThunk("client/getProvidersInfo", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/get-info`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.client);
    return res.data.client;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers info");
  }
});

export const updateClientInfo = createAsyncThunk(
  "client/updateClientInfo",
  async ({ formData, token }, thunkAPI) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const data = new FormData();

      // Append fields dynamically (ignore undefined or blank values)
      for (const key in formData) {
        if (
          formData[key] !== undefined &&
          formData[key] !== null &&
          formData[key] !== ""
        ) {
          data.append(key, formData[key]);
        }
      }

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/client/update-info`,
        data,
        config
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to update provider info"
      );
    }
  }
);

export const clientVerify = createAsyncThunk(
  "client/verification",
  async ({ formData, clientId }, thunkAPI) => {
    const type = "client";
    try {
      const data = new FormData();
      data.append("file-input", formData.fileInputs.selfie);
      data.append("file-input", formData.fileInputs.front);
      data.append("file-input", formData.fileInputs.back);

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/provider/verification/${type}/${clientId}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to verify client"
      );
    }
  }
);

const clientInfoSlice = createSlice({
  name: "clientInfo",
    initialState: {
      clientsInfo: null,
      isClientVerified: false,
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getClientInfo.pending, (state) => {
            state.loading = true;
        })
        .addCase(getClientInfo.fulfilled, (state, action) => {
            state.clientsInfo = action.payload;
            state.isClientVerified = action.payload.is_verified === "Y";
            state.loading = false;
        })
        .addCase(getClientInfo.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch client info"; 
            state.loading = false;
        })
        .addCase(updateClientInfo.fulfilled, (state, action) => {
                    state.clientsInfo = action.payload;
                    state.loading = false;
                })
        },
});

export default clientInfoSlice.reducer;